/**
 * Enum of AugLoop Scenarios from end-user perspective
 * @codegen
 */
export var Scenario;
(function (Scenario) {
    Scenario["Unknown"] = "Unknown";
    Scenario["Testing"] = "Testing";
    Scenario["CopilotSummary"] = "Copilot Summary";
    Scenario["CopilotCompose"] = "Copilot Compose";
    Scenario["Rewrite"] = "Copilot Rewrite";
    Scenario["ChatQnA"] = "Copilot Chat Question & Answer";
    Scenario["CIQ"] = "Context IQ";
    Scenario["Editor"] = "Editor";
    Scenario["Handoff"] = "Handoff";
    Scenario["ReadAloud"] = "Read Aloud";
})(Scenario || (Scenario = {}));
//# sourceMappingURL=scenarios.js.map